module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.b2d307df.ttf";